import React from 'react';
import './Homepage.css';
import Carousel from 'react-bootstrap/Carousel';

const TopAutoSlide = () => {
  return (
 <>
  <div className="container-fluid" id='homepage-top-slide'>
  <Carousel controls={false} className="slider" pause={"hover"|false}>
      <Carousel.Item className="slider-item item-1" interval={5000} >
        <div className="row">
            <div className="col
            left-col">
                <h1>Diverse Product Portfolio</h1>
                <p>"Unique Technologies specializes in a diverse array of products, including solar panels, tube well/pump automation systems, street light automation systems, application software development, flow meters with remote monitoring systems, and PLC, Drive, HMI, and SCADA solutions.."</p>
            </div>
            <div className="col right-col">
             &nbsp;
            </div>
        </div>
      </Carousel.Item>
      <Carousel.Item className="slider-item item-2" interval={5000}>
      <div className="row">
            <div className="col
            left-col">
                <h1>Efficiency Elevated: Our Solar Water Pump Automation System</h1>
                <p>"Streamline irrigation processes with our cutting-edge solar water pump automation system, enhancing productivity, conserving energy, and promoting eco-friendly agricultural practices effortlessly."</p>
            </div>
            <div className="col right-col">
             &nbsp;
            </div>
        </div>
      </Carousel.Item >
      <Carousel.Item className="slider-item item-3" interval={5000}>
      <div className="row">
            <div className="col
            left-col">
                <h1>Efficient Water Management</h1>
                <p>"The company's tube well/pump automation systems optimize water usage through intelligent automation, ensuring efficient water management for agricultural, industrial, and domestic purposes."</p>
            </div>
            <div className="col right-col">
             &nbsp;
            </div>
        </div>
      </Carousel.Item>
      <Carousel.Item className="slider-item item-4" interval={5000}>
      <div className="row">
            <div className="col
            left-col">
                <h1>Smart Street Lighting</h1>
                <p>" Unique Technologies' street light automation systems utilize cutting-edge technology to intelligently manage and control lighting infrastructure, enhancing energy efficiency and safety in urban and rural areas."</p>
            </div>
            <div className="col right-col">
             &nbsp;
            </div>
        </div>
      </Carousel.Item>
      <Carousel.Item className="slider-item item-5" interval={5000}>
      <div className="row">
            <div className="col
            left-col">
                <h1>Application Software Development</h1>
                <p>" Leveraging expertise in software development, Unique Technologies delivers bespoke application software tailored to meet the unique needs of clients, empowering businesses with streamlined operations and enhanced productivity."</p>
            </div>
            <div className="col right-col">
             &nbsp;
            </div>
        </div>
      </Carousel.Item>
      <Carousel.Item className="slider-item item-6" interval={5000}>
      <div className="row">
            <div className="col
            left-col">
                <h1>Integrated Monitoring Solutions</h1>
                <p>"The company offers flow meters with remote monitoring systems, coupled with PLC, Drive, HMI, and SCADA solutions, providing comprehensive monitoring and control capabilities for industrial processes, ensuring efficiency and reliability."</p>
            </div>
            <div className="col right-col">
             &nbsp;
            </div>
        </div>
      </Carousel.Item>
    </Carousel>
  </div>
 </>
  )
}

export default TopAutoSlide
